import {
  Divider as MuiDivider,
  DividerProps as MuiDividerProps,
} from '@mui/material';

export interface DividerProps extends MuiDividerProps {
  // Extend with custom props if needed
  spacing?: number;
}

export const Divider = ({ spacing, sx, ...props }: DividerProps) => {
  const spacingStyles = spacing
    ? {
        my: spacing,
      }
    : {};

  return <MuiDivider sx={{ ...spacingStyles, ...sx }} {...props} />;
};

export default Divider;
